"use client";
import { useEffect } from "react";
import { init } from "@innoapm/sdk-nextjs/client";

export function InnoApmInit() {
  useEffect(() => {
    init({
      dsn: process.env.NEXT_PUBLIC_INNOAPM_DSN!,
      environment: process.env.NODE_ENV,
      release: process.env.NEXT_PUBLIC_INNOAPM_RELEASE,
      tracesSampleRate: 0.2,
    });
  }, []);
  return null;
}
